import React, { useState, useEffect } from "react";
import "./style.css";
import icon from "../assets/Icon.png"
import { useNavigate, useLocation } from "react-router-dom";
import { url } from "../env";
import Loader from "../components/loader";
import PopUp from "../components/popUp";



export default function AdminLogin() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [keepLoggedIn, setKeepLoggedIn] = useState(false);
    const [loginData, setLoginData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [popupActive,setPopUpActive]= useState({
        active:false,
        type:"",
        title:"",
        description:""
    })
    

    const navigate = useNavigate();
    const data = JSON.parse(localStorage.getItem("attendance_teacher")? localStorage.getItem("attendance_teacher") : sessionStorage.getItem("attendance_teacher"))
    const location = useLocation();
    useEffect(() => {
        if (!data?.token) {
            navigate("/admin-login");
        } else {
            navigate("/admin-dashboard");
        }
    }, [data, navigate]);

    useEffect(() => {
        if (popupActive.active) {
            const timer = setTimeout(() => {
                setPopUpActive((prevState) => ({
                    ...prevState,
                    active: false,
                    type:"",
                    title:"",
                    description:""
                }));
            }, 4000); 

            return () => clearTimeout(timer); 
        }
    }, [popupActive.active]);

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Username:", username);
        console.log("Password:", password);
        console.log("Keep me logged in:", keepLoggedIn);
        // navigate("/all-courses");
        setLoading(true)
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var raw = JSON.stringify({
            userName: username,
            password: password,
        })
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };
        fetch(`${url}Authentication/Login`, requestOptions)
            .then(response => response.json())
            .then(result => {
                setLoading(false)
                console.log(result);
                if (result.status == 200) {
                    setUsername("")
                    setPassword("")
                    navigate("/admin-dashboard")
                    setLoginData(result.data) ;
                    keepLoggedIn ?  localStorage.setItem("attendance_teacher", JSON.stringify(result.data)) : sessionStorage.setItem("attendance_teacher", JSON.stringify(result.data));
                    return
                } else if (result.status == 401) {
                    setPopUpActive({
                        active:true,
                        type:"warning",
                        title:"Alert",
                        description:result.message
                    })
                }
            }).catch((err) => {
                setLoading(false)
                console.log(err)
                setUsername("")
                setPassword("")
                setPopUpActive({
                    active:true,
                    type:"alert",
                    title:"Alert",
                    description:"Something went wrong, Try again."
                })
            })
    };


    return (
        <div className="login-container">
            <div className="loginHeader">
                <div className="logo">
                    <img src={icon} alt="" />
                </div>
                <h1>ICDC Attendance System</h1>
            </div>
            <form className="login-form" onSubmit={handleSubmit}>
                <h1>Admin Login</h1>
                <div className="form-group">
                    <label htmlFor="username">Username</label>
                    <input
                        type="text"
                        id="username"
                        name="username"
                        placeholder="Enter your username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="password">Password</label>
                    <input
                        type="password"
                        id="password"
                        name="password"
                        placeholder="Enter your password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group checkbox-group">
                    <input
                        type="checkbox"
                        id="keepLoggedIn"
                        checked={keepLoggedIn}
                        onChange={(e) => setKeepLoggedIn(e.target.checked)}
                    />
                    <label htmlFor="keepLoggedIn">Keep me logged in</label>
                </div>
                <button type="submit" className="login-button">Login</button>
            </form>
            {loading && <Loader />}
            {popupActive.active && <PopUp type={popupActive.type} title={popupActive.title} description={popupActive.description} />}
        </div>
    );
}
